import { application } from "./application"
import ModalController from "./modal_controller"
import Select2Controller from "./select2_controller"
import AppendSelectOptionController from "./append_select_option_controller"
import AlertMessageController from "./alert_message_controller"
import ContactFormController from "./contact_form_controller"
import ContactCreatedController from "./contact_created_controller"
import CompleteRowController from "./complete_row_controller"
import SingleSubmitController from "./single_submit_controller"
import PlaceFormController from "./place_form_controller"
import SubmitShortcutController from "./submit_shortcut_controller"
import PwaStatusController from "./pwa_status_controller"
import OfflineRefreshController from "./offline_refresh_controller"
import OfflineSubmitController from "./offline_submit_controller"
import OfflineOutboxOverlayController from "./offline_outbox_overlay_controller"
import BulkDownloadController from "./bulk_download_controller"
import RecurrenceController from "./recurrence_controller"
import PasskeyLoginController from "./passkey_login_controller"
import PasskeyRegistrationController from "./passkey_registration_controller"

application.register("modal", ModalController)
application.register("select2", Select2Controller)
application.register("append-select-option", AppendSelectOptionController)
application.register("alert-message", AlertMessageController)
application.register("contact-form", ContactFormController)
application.register("contact-created", ContactCreatedController)
application.register("complete-row", CompleteRowController)
application.register("single-submit", SingleSubmitController)
application.register("place-form", PlaceFormController)
application.register("submit-shortcut", SubmitShortcutController)
application.register("pwa-status", PwaStatusController)
application.register("offline-refresh", OfflineRefreshController)
application.register("offline-submit", OfflineSubmitController)
application.register("offline-outbox-overlay", OfflineOutboxOverlayController)
application.register("bulk-download", BulkDownloadController)
application.register("recurrence", RecurrenceController)
application.register("passkey-login", PasskeyLoginController)
application.register("passkey-registration", PasskeyRegistrationController)
